"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VektorioProjects = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var ProjectList_1 = require("../ProjectList");
var ListHeader_1 = require("../../../ListHeader");
var ListRow_1 = require("./components/ListRow");
var dispatchers_1 = require("./utils/dispatchers");
var getConnectState = function (state) { return state.vektorio.connect; };
var VektorioProjects = function () {
    var dispatchers = (0, dispatchers_1.mapDispatchers)((0, react_redux_1.useDispatch)());
    var connectState = (0, react_redux_1.useSelector)(getConnectState);
    var mapItem = function (item) { return (React.createElement(ListRow_1.ListRow, { item: item, selected: connectState.selectedProjects, select: dispatchers.select, deselect: dispatchers.deselect })); };
    return (React.createElement("div", { className: 'vektorio-projects' },
        React.createElement("h3", null, (0, translation_1.getLocalization)('vektorio/vektorioProjects')),
        React.createElement(ProjectList_1.ProjectList, { className: 'vektorio-projects-list', status: connectState.linkableProjectsStatus },
            React.createElement(ListHeader_1.ListHeader, { title: (0, translation_1.getLocalization)('vektorio/connect/vektorioProjects/name') }),
            connectState.linkableProjects.map(mapItem))));
};
exports.VektorioProjects = VektorioProjects;
